import {createAction} from 'redux-act';
import {AxiosPromise} from 'axios';

import {instanceGusaBackend} from 'libs/api';
import {ENDPOINTS} from 'constants/endpoints';
import {CART} from 'constants/actions';
import {AddToCartType} from 'pages/cart/store/actions/addToCart/addToCartType';
import {QuoteItemV2Type} from 'constants/flow/flowTypesCart';

/**
 * Clear cart add.
 */
export const clearCartAdd = createAction(CART.CLEAR_CART_ADD);

/**
 * Get cart items count
 */
export const getItemsCount = createAction<AxiosPromise<{count: number}>>(CART.GET_ITEMS_COUNT, () =>
    instanceGusaBackend({
        method: 'get',
        url: ENDPOINTS.CART_GET_COUNT,
    }),
);

export const fetchQuoteItemV2 = createAction<AxiosPromise<number>, QuoteItemV2Type>(
    'FETCH_QUOTE_ITEM_V2',
    (id: number) => {
        return instanceGusaBackend({
            method: 'GET',
            url: `${ENDPOINTS.CART_PUT_GET_QUOTE_ITEM_V2}/${id}`,
        });
    },
);

export const addToCartV2 = createAction<AxiosPromise<AddToCartType>, AddToCartType>(
    'ADD_TO_CART',
    (data: AddToCartType) => {
        return instanceGusaBackend({
            method: 'POST',
            headers: {Authorization: ''},
            url: ENDPOINTS.ADD_TO_CART_V2,
            data: {...data, productAsHTO: data.productAsHTO || 0},
        });
    },
    (meta: AddToCartType) => meta,
);

/**
 * it adds to cart reordered contact lenses
 * @param {string} reorderToken - reorder token
 * @return {ActionType<AxiosPromise>} Action
 */
export const addToCartReorderCL = createAction<AxiosPromise<AxiosPromise>>(
    'ADD_TO_CART_REORDER',
    (reorderToken: string) =>
        instanceGusaBackend({
            method: 'POST',
            url: ENDPOINTS.CART_REORDER,
            data: {
                token: reorderToken,
            },
        }),
);
